import React from "react";
import PropTypes from "prop-types";
import useDelayedReveal from "../../hooks/common/useDelayedReveal";

/**
 * The quiet tier: a slim progress bar pinned to the top of the viewport.
 *
 * Route transitions and page-data fetches are usually over in a few hundred
 * milliseconds. Handing those the full-screen loader is what made the app feel
 * slow -- a takeover implies a long wait, so the eye reads every one of them as
 * long. This keeps the page you are already looking at on screen.
 *
 * `blocking` keeps the invisible scrim that the old full-screen overlay
 * provided, so screens that relied on it to swallow clicks mid-request still
 * do.
 */
const RouteLoader = ({ label, blocking, revealDelayMs }) => {
  const isRevealed = useDelayedReveal(revealDelayMs);

  if (!isRevealed) return null;

  return (
    <>
      {blocking && <div className="cc-routeloader__scrim" aria-hidden="true" />}
      <div
        className="cc-routeloader"
        role="status"
        aria-live="polite"
        aria-label={label}
      >
        <span className="cc-routeloader__bar" />
      </div>
    </>
  );
};

RouteLoader.propTypes = {
  label: PropTypes.string,
  blocking: PropTypes.bool,
  revealDelayMs: PropTypes.number,
};

RouteLoader.defaultProps = {
  label: "Loading",
  blocking: true,
  revealDelayMs: 150,
};

export default RouteLoader;
